export {
  axisLeft,
  axisBottom,
  axisTop
} from 'd3-axis'

export {
  curveStep,
  line
} from 'd3-shape'

export {
  extent,
  max
} from 'd3-array'

export {
  scaleBand,
  scaleLinear,
  scaleOrdinal,
  scaleTime
} from 'd3-scale'

export {
  select,
  selectAll
} from 'd3-selection'

export {
  timeParse,
  timeFormat
} from 'd3-time-format'

export {
  rgb
} from 'd3-color'



// WEBPACK FOOTER //
// ./src/scripts/lib/d3.js